// src/lib/progressCalc.ts
import { parseISO } from "../../utils/date";

/** 날짜를 00:00로 정규화 */
function atStartOfDay(d: Date) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
}

/**
 * asOf 날짜 기준 PV(%) 계산
 * - plannedStart/Finish가 없거나 순서가 잘못되면 null
 * - [0, 100]로 클램프
 */
export function plannedPercentAsOf(
    plannedStart?: string | null,
    plannedFinish?: string | null,
    asOfDate: Date = new Date(),
): number | null {
    if (!plannedStart || !plannedFinish) return null;
    const s = parseISO(plannedStart);
    const e = parseISO(plannedFinish);
    if (!s || !e || isNaN(+s) || isNaN(+e) || e < s) return null;

    const asOf = atStartOfDay(asOfDate);
    const start = atStartOfDay(s);
    const end = atStartOfDay(e);

    const total = end.getTime() - start.getTime();
    if (total <= 0) return end <= asOf ? 100 : 0;

    const elapsed = Math.min(Math.max(asOf.getTime() - start.getTime(), 0), total);
    const pct = (elapsed / total) * 100;
    return Math.max(0, Math.min(100, pct));
}

/** SPI = EV / PV. PV가 0 또는 null이면 null */
export function calcSPI(earnedValue?: number | null, plannedPct?: number | null): number | null {
    if (earnedValue == null || plannedPct == null || plannedPct <= 0) return null;
    return earnedValue / plannedPct;
}
